export enum RequestFilterValueTypeEnums {
    STRING = 1,
    NUMBER = 2,
    DATE = 3,
    BOOLEAN = 4,
}

export enum RequestFilterOperationTypeEnum {
    CONTIANS = 1,
    GREATER_THAN = 2,
    LOWER_THAN = 3,
    GREATER_AND_EQUAL = 4,
    LOWER_AND_EQUAL = 5,
    EQUALS = 6,
    IN = 7
}

export function mapReactMUIToFilterOperationTypes(muiType: String) {

    if (muiType == "contains") {
        return RequestFilterOperationTypeEnum.CONTIANS;
    }
    else if (muiType == "equals") {
        return RequestFilterOperationTypeEnum.EQUALS;
    }
    else {
        return RequestFilterOperationTypeEnum.EQUALS;
    }
}

export function mapReactFilterValueTypeToRequestFilterValueType(value: any, type?: any) {

    if (type !== undefined) return type; // Prioritize the explicitly provided type

    if (value == "true" || value == "false") {
        return RequestFilterValueTypeEnums.BOOLEAN;
    }

    if (!isNaN(value) && !isNaN(parseFloat(value))) { // More robust check for number
        return RequestFilterValueTypeEnums.NUMBER;
    }

    if (typeof value == "string") {
        return RequestFilterValueTypeEnums.STRING;
    } else if (typeof value == "number") {
        return RequestFilterValueTypeEnums.NUMBER;
    } else if (typeof value == "boolean") {
        return RequestFilterValueTypeEnums.BOOLEAN;
    }
    return RequestFilterValueTypeEnums.STRING; // Default to string if no type is determined
}